



















































































import { Component, Vue, Prop } from 'vue-property-decorator';
import Client from '../../../models/Client';
import clients from '../../../store/modules/clients';

@Component
export default class BillingForm extends Vue {
  @Prop() private client!: any;

  private form: any = {
    id: this.client?.holded.id,
    billingAddress: {
      customId: this.client?.holded.id,
      name: this.client?.holded.restaurantName,
      email: '',
      code: '',
      address: '',
      city: '',
      postalCode: '',
      country: '',
    },
  };

  private async onSubmit(event: any) {
    event.preventDefault();
    try {
      const res = await clients.createHoldedContact(this.form);
      if (res.status === 201) {
        this.$emit('success', {
          info: `This contact was created successfully`,
          contact: res.data,
        });
      } else {
        this.$emit('error', res.error);
      }
    } catch (err) {
      this.$emit('error', err.message);
    }
  }
}
